import { ErrorMessage, StringPropertyTextArea, TextAreaResizeMode, VList, VRootObject } from "@1oo4/miv";
import { DocClient } from "../../shared/docclient";
import { handleError, MIVPage, runAsync } from "../../shared/pages";
import { MRootDoc } from "../../shared/model/masterdata";
import { VChapter, VSectionEdit } from "./views";
import { MChapter, MContent, MSection } from "../../shared/model/mdoc";
import "./edit.css";

export class EditPage extends MIVPage {

    private root: VRootEdit | undefined;
    readonly panelChapters: HTMLDivElement;
    private readonly partSection: HTMLDivElement;
    private readonly sectionContainer: HTMLDivElement;

    constructor() {
        super("page_edit", "edit", "nav_edit");

        //StringPropertyTextArea.DefaultResizeMode = TextAreaResizeMode.FIELD_SIZING;

        this.panelChapters = document.getElementById("page_edit_chapters") as HTMLDivElement

        this.partSection = document.getElementById("page_edit_part_section") as HTMLDivElement
        this.partSection.style.display = "none";

        this.sectionContainer = document.getElementById("page_edit_section_container") as HTMLDivElement

        const bAddChapter = document.getElementById("page_edit_b_add_chapter") as HTMLButtonElement
        bAddChapter.onclick = () => this.addChapter();

        const bAddText = document.getElementById("page_edit_b_add_text") as HTMLButtonElement
        bAddText.onclick = () => this.addText();
        const bAddTable = document.getElementById("page_edit_b_add_table") as HTMLButtonElement
        bAddTable.onclick = () => this.addTable();
        const bAddImage = document.getElementById("page_edit_b_add_image") as HTMLButtonElement
        bAddImage.onclick = () => this.addImage();
        const bAddCode = document.getElementById("page_edit_b_add_code") as HTMLButtonElement
        bAddCode.onclick = () => this.addCode();
    }

    //#region  ACTIONS

    private async addChapter() {
        if (this.root !== undefined) {
            const m = await runAsync(this.root.Model.AppendChapterAsync());
            if (m === undefined) {
                handleError(this.root.Model.Client.Error, true);
            }
        }
    }
    private addText() {
        this.addContent((x: MSection) => x.AppendTextAsync());
    }
    private addImage() {
        this.addContent((x: MSection) => x.AppendImageAsync());
    }
    private addCode() {
        this.addContent((x: MSection) => x.AppendCodeAsync());
    }
    private addTable() {
        this.addContent((x: MSection) => x.AppendTable2x2Async());
    }
    private async addContent<C extends MContent>(mkr: (x: MSection) => Promise<C | undefined>) {
        if (this._selected_section_doc_ !== undefined) {
            const created = await runAsync(mkr(this._selected_section_doc_.Model));
            if (created === undefined) {
                handleError(this.root?.Model.Client.Error, true);
            }
        }
    }

    //#endregion

    //#region  OPEN / CLOSE

    async OpenAsync(): Promise<void> {
        if (this.root === undefined) {
            const client = await DocClient.getClientAsync();
            if (client instanceof ErrorMessage) {
                handleError(client, true);
                return;
            }
            this.root = new VRootEdit(client.DocRoot, this);
            await this.root.DisplayAsync();
            if (client.UserID <= 0) {
                const signinPanel = document.getElementById("signin_panel");
                if (signinPanel) signinPanel.style.display = '';
            }
        }
    }
    Close(): void {
        //this.root?.HideAsync();
    }

    protected ResolvePathAndNavigateAsync(path: string, samePathAsCurrent: boolean): Promise<void> {
        return Promise.resolve();
    }

    //#endregion


    private _selected_section_doc_: VSectionEdit | undefined;
    set selectedCSection(value: VSectionEdit | undefined) {
        if (value != this._selected_section_doc_) {
            if (this._selected_section_doc_ !== undefined) {
                this._selected_section_doc_.setSelected(false);
                this.sectionContainer.removeChild(this._selected_section_doc_.panelContent);
            }
            this._selected_section_doc_ = value;
            if (value === undefined) {
                this.partSection.style.display = "none";
            } else {
                this.partSection.style.display = '';
                value.setSelected(true);
                this.sectionContainer.appendChild(value.panelContent);
            }
        }
    }
    get selectedCSection(): VSectionEdit | undefined {
        return this._selected_section_doc_;
    }
}

export class VRootEdit extends VRootObject<MRootDoc> {

    readonly page: EditPage;
    readonly chapters: VList<VChapter, MChapter>;

    constructor(m: MRootDoc, page: EditPage) {
        super(m);
        this.page = page;
        this.chapters = new VList<VChapter, MChapter>(m.Chapters, this, x => new VChapter(x, this));
    }
}